import React from 'react';
import { MapPin, PlusCircle, Menu, ExternalLink } from 'lucide-react';
import { Button } from './ui/Button';
export function Header() {
  return <header className="sticky top-0 z-50 w-full border-b bg-white shadow-sm" data-id="element-171">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between gap-4" data-id="element-172">
        {/* Logo & Location */}
        <div className="flex items-center gap-6" data-id="element-173">
          <a href="#" className="flex items-center gap-2" data-id="element-174">
            <img src="https://cdn.magicpatterns.com/uploads/bitF4Fp2Mn5F2xN1PkGCY5/locanto_color.svg" alt="Locanto" className="h-8" data-id="element-175" />
          </a>

          <div className="hidden md:flex items-center text-gray-600 text-sm hover:text-[#00897B] cursor-pointer transition-colors" data-id="element-176">
            <MapPin className="h-4 w-4 mr-1" data-id="element-177" />
            <span data-id="element-178">Singapore</span>
          </div>
        </div>

        {/* Enter Website Buttons - Desktop */}
        <div className="hidden md:flex flex-1 max-w-xl mx-auto justify-center gap-3" data-id="element-179">
          <a href="https://www.geylang777-5.site" target="_blank" rel="noopener noreferrer" data-id="element-180">
            <Button variant="default" className="gap-2 px-6" data-id="element-181">
              <ExternalLink className="h-4 w-4" data-id="element-182" />
              Enter Website
            </Button>
          </a>
          <a href="https://www.cfge.me" target="_blank" rel="noopener noreferrer" data-id="element-183">
            <Button variant="default" className="gap-2 px-6" data-id="element-184">
              <ExternalLink className="h-4 w-4" data-id="element-185" />
              新加坡春风阁
            </Button>
          </a>
        </div>

        {/* Actions */}
        <div className="flex items-center gap-3" data-id="element-186">
          <Button variant="ghost" className="hidden md:flex text-gray-600 hover:text-[#00897B]" data-id="element-187">
            Log in
          </Button>
          <a href="https://t.me/gl777net" target="_blank" rel="noopener noreferrer" data-id="element-188">
            <Button variant="orange" className="gap-2 shadow-sm" data-id="element-189">
              <PlusCircle className="h-4 w-4" data-id="element-190" />
              <span className="hidden sm:inline" data-id="element-191">Post Free Ad</span>
              <span className="sm:hidden" data-id="element-192">Post</span>
            </Button>
          </a>
          <Button variant="ghost" size="icon" className="md:hidden" data-id="element-193">
            <Menu className="h-6 w-6 text-gray-600" data-id="element-194" />
          </Button>
        </div>
      </div>

      {/* Mobile Enter Website Buttons */}
      <div className="md:hidden px-4 pb-3 space-y-2" data-id="element-195">
        <a href="https://www.geylang777-5.site" target="_blank" rel="noopener noreferrer" className="block" data-id="element-196">
          <Button variant="default" className="w-full gap-2" data-id="element-197">
            <ExternalLink className="h-4 w-4" data-id="element-198" />
            Enter Website
          </Button>
        </a>
        <a href="https://www.cfge.me" target="_blank" rel="noopener noreferrer" className="block" data-id="element-199">
          <Button variant="default" className="w-full gap-2" data-id="element-200">
            <ExternalLink className="h-4 w-4" data-id="element-201" />
            新加坡春风阁
          </Button>
        </a>
      </div>
    </header>;
}